import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { useGraphQL } from "@/hooks/use-graphql";
import { getCurrentDate } from "@/lib/helpers/date";
import { PlanMenu } from "@/components/plan/plan-menu";

import type { JSX } from "react";

const MyPlanPageQuery = graphql(/* GraphQL */ `
  query MyPlanPageQuery($currentDate: datetime2!) {
    ...PlanMenuFragment
  }
`);

const PlanPage = (): JSX.Element => {
  const queryResult = useGraphQL(MyPlanPageQuery, {
    currentDate: getCurrentDate().toISOString(),
  });

  const { data } = queryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Meu plano" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...queryResult}>
          {data ? <PlanMenu data={data} /> : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/profile/plan/")({
  component: PlanPage,
});
